var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mx-element',{attrs:{"type":"ColumnFrame","theme":"tab","value":_vm.Index,"options":_vm.columns},on:{"change":_vm.OnClick}},[_vm._l((_vm.columns),function(col,index){return [(index === _vm.Index)?_c('div',{key:index},[_vm._t("default",null,{"config":col,"index":index})],2):_vm._e()]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }